export enum Gender {
    Female = 1,
    Male,
    Other
}
